import React from 'react';
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Link,
} from '@mui/material';

// I18N
import ErrorsFormattedMessages from '../../../messages/websms/ErrorsFormattedMessages';

// UTILS
import { getZoneOffsettedDate } from '../../../utils/dates';
import { errorCodes } from '../../../utils/errorCodes';

const ErrorsTable = ({
  isSearching,
  failed,
  setMessageSelected,
  setMessage,
}) => {
  const renderErrorTable = () => {
    if (isSearching) {
      return (
        <TableRow>
          <TableCell colSpan={7} sx={{ paddingY: 2 }}>
            <Typography>{ErrorsFormattedMessages.searchingText}</Typography>
          </TableCell>
        </TableRow>
      );
    } else if (failed.length === 0) {
      return (
        <TableRow>
          <TableCell colSpan={7} sx={{ paddingY: 2 }}>
            <Typography>{ErrorsFormattedMessages.noResult}</Typography>
          </TableCell>
        </TableRow>
      );
    } else {
      return failed.map((message, index) => {
        const errorText = message?.error_code_text
          ? errorCodes(message.error_code_text)
          : '';

        let smsText;
        try {
          smsText = decodeURIComponent(message.sms_text);
        } catch (err) {
          smsText = 'ERROR: MALFORMED TEXT';
        }
        return (
          <TableRow key={message.sms_id}>
            <TableCell>{getZoneOffsettedDate(message.sms_sent)}</TableCell>
            <TableCell>{message.originator}</TableCell>
            <TableCell>{message.dest_tn || ''}</TableCell>
            <TableCell>{message.dest_name || message.dest_tn || ''}</TableCell>
            <TableCell>
              <Link
                onClick={() => {
                  setMessageSelected(true);
                  setMessage(message);
                }}
                tabIndex={0}
              >
                {decodeURIComponent(message.sent_flag_name)}
              </Link>
            </TableCell>
            <TableCell>{errorText.roxCode || ''}</TableCell>
            <TableCell>{errorText.meaning || ''}</TableCell>
          </TableRow>
        );
      });
    }
  };

  return (
    <TableContainer
      sx={{
        marginBottom: 4,
        overflowX: 'auto',
        width: '100%',
        whiteSpace: 'nowrap',
      }}
    >
      <Table variant="rounded">
        <TableHead>
          <TableRow>
            <TableCell width="15%">
              {ErrorsFormattedMessages.tableHeaderDateTime}
            </TableCell>
            <TableCell width="10%">
              {ErrorsFormattedMessages.fromHeader}
            </TableCell>
            <TableCell width="10%">
              {ErrorsFormattedMessages.toHeader}
            </TableCell>
            <TableCell width="15%">
              {ErrorsFormattedMessages.nameHeader}
            </TableCell>
            <TableCell width="15%">
              {ErrorsFormattedMessages.tableHeaderErrorStatus}
            </TableCell>
            <TableCell width="10%">
              {ErrorsFormattedMessages.tableHeaderErrorCode}
            </TableCell>
            <TableCell width="15%">
              {ErrorsFormattedMessages.tableHeaderErrorText}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{renderErrorTable()}</TableBody>
      </Table>
    </TableContainer>
  );
};

export default ErrorsTable;
